// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"329":"3bd1b8f2666a0b29","5680":"68a8a8b361460ac4","8583":"2033860a64efe1c9"}[chunkId] + ".js";
};